export default {
    // 'form.serial_no': 'submit',
}
